/* Luban Pride — "Make it a gift" on the product page.
   When the shopper ticks the option and fills in two names + a sentence, the
   Add-to-Cart click is intercepted and TWO lines are added together: the product
   itself, plus the paid "Gift Message" line carrying the three fields as line
   item properties. When the option is off, the theme's normal add proceeds. */
(function () {
  'use strict';

  /* Match any add-to-cart form by its action — class names vary between the
     main form (hdt-main-product-form), the sticky bar and bundle forms. */
  function isAddForm(form) {
    if (!form) return false;
    var action = form.getAttribute('action') || form.action || '';
    return action.indexOf('/cart/add') !== -1 ||
           /hdt-(main-)?product-form|hdt-sticky-atc__form/.test(form.className || '');
  }

  function block() { return document.querySelector('[data-lp-gift-block]'); }
  function inFlight() { return block() && block().dataset.lpBusy === '1'; }

  /* ---- panel show/hide + hide express checkout while gifting ---- */
  document.addEventListener('change', function (e) {
    var toggle = e.target.closest('[data-lp-gift-toggle]');
    if (!toggle) return;
    var b = toggle.closest('[data-lp-gift-block]');
    var panel = b && b.querySelector('[data-lp-gift-panel]');
    if (panel) panel.hidden = !toggle.checked;
    // The dynamic-checkout button would bypass the extra line, so hide it while on.
    document.querySelectorAll('.hdt-product-form .shopify-payment-button, .shopify-payment-button').forEach(function (el) {
      el.style.display = toggle.checked ? 'none' : '';
    });
    if (toggle.checked && panel) {
      var first = panel.querySelector('[data-lp-gift-name1]');
      if (first) first.focus();
    }
    clearError(b);
  });

  function clearError(b) {
    if (!b) return;
    var err = b.querySelector('[data-lp-gift-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    b.querySelectorAll('.lp-gift__field--invalid').forEach(function (f) { f.classList.remove('lp-gift__field--invalid'); });
  }

  function fieldWrap(input) { return input ? input.closest('.lp-gift__field') : null; }

  function collect(b) {
    var n1 = b.querySelector('[data-lp-gift-name1]');
    var n2 = b.querySelector('[data-lp-gift-name2]');
    var msg = b.querySelector('[data-lp-gift-message]');
    return {
      name1: n1, name2: n2, msg: msg,
      v1: (n1.value || '').trim(),
      v2: (n2.value || '').trim(),
      vm: (msg.value || '').trim()
    };
  }

  function validate(b) {
    clearError(b);
    var f = collect(b);
    // Only the first name is required; the second name and the sentence are
    // optional, so a shopper can print just one name.
    var missing = [];
    if (!f.v1) missing.push(f.name1);
    if (missing.length) {
      missing.forEach(function (el) { var w = fieldWrap(el); if (w) w.classList.add('lp-gift__field--invalid'); });
      var err = b.querySelector('[data-lp-gift-error]');
      if (err) {
        err.textContent = b.dataset.validationError || '';
        err.hidden = false;
      }
      missing[0].focus();
      return null;
    }
    return f;
  }

  /* ---- read what the form would actually submit (respects variant picker) ---- */
  function readMainLine(form) {
    var id = null, qty = 1;
    try {
      var fd = new FormData(form);
      id = fd.get('id');
      qty = fd.get('quantity') || 1;
    } catch (e) {}
    if (!id) {
      var idEl = form.querySelector('[name="id"]');
      if (idEl) id = idEl.value;
    }
    id = id && String(id).replace(/\D/g, '');
    qty = parseInt(qty, 10) || 1;
    return id ? { id: id, quantity: qty } : null;
  }

  function doGiftAdd(form, b) {
    if (inFlight()) return;
    var f = validate(b);
    if (!f) return;
    var main = readMainLine(form);
    if (!main) return; // let the theme handle a malformed form
    if (!(window.LubanCartDrawer && window.LubanCartDrawer.addItemsAndOpen)) return;
    var feeId = b.dataset.feeVariant ? b.dataset.feeVariant.replace(/\D/g, '') : '';

    // The three fields ride on the product's own line, so they survive even when
    // no paid line exists yet.
    // Skip blanks so the cart and the order only carry what was filled in.
    var props = {};
    props[b.dataset.labelName1 || 'First name'] = f.v1;
    if (f.v2) props[b.dataset.labelName2 || 'Second name'] = f.v2;
    if (f.vm) props[b.dataset.labelMessage || 'Message'] = f.vm;

    b.dataset.lpBusy = '1';
    var btns = form.querySelectorAll('button[name="add"]');
    btns.forEach(function (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('hdt-btn-loading'); });

    var items = [{ id: main.id, quantity: main.quantity, properties: props }];
    if (feeId) items.push({ id: feeId, quantity: 1 });

    window.LubanCartDrawer.addItemsAndOpen(items).then(function () {
      b.dataset.lpBusy = '0';
      btns.forEach(function (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('hdt-btn-loading'); });
    }).catch(function () {
      b.dataset.lpBusy = '0';
      btns.forEach(function (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('hdt-btn-loading'); });
      var err = b.querySelector('[data-lp-gift-error]');
      if (err) { err.textContent = b.dataset.addError || ''; err.hidden = false; }
    });
  }

  /* ---- intercept Add-to-Cart at the earliest point (capture phase) ---- */
  function intercept(e) {
    var b = block();
    if (!b) return;
    var toggle = b.querySelector('[data-lp-gift-toggle]');
    if (!toggle || !toggle.checked) return; // option off → native add
    var btn = e.target.closest('button[name="add"]');
    if (!btn) return;
    var form = btn.closest('form');
    if (!isAddForm(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    doGiftAdd(form, b);
  }
  document.addEventListener('click', intercept, true);
  document.addEventListener('submit', function (e) {
    var b = block();
    if (!b) return;
    var toggle = b.querySelector('[data-lp-gift-toggle]');
    if (!toggle || !toggle.checked) return;
    var form = e.target;
    if (isAddForm(form)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      doGiftAdd(form, b);
    }
  }, true);
})();
